<template>
  <Label
    :text="t('ai')"
    icon-name="generateAiVideoPrimaryIcon"
    :color="LabelColors.Blue"
    :size="LabelSizes.Small"
  />
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import Label from '@/components/common/label/Label.vue'
import { LabelColors, LabelSizes } from '@/components/common/label/utils'

const { t } = useI18n()
</script>
